import * as React from 'react';
import { Fileupload } from 'sos-common/js/components/Fileupload/Fileupload';
import { IFileUploadProps } from 'sos-common/js/components/Fileupload/Fileupload.types';
import { DeleteButton } from 'sos-eservice-common/js/components/General/DeleteButton';
import { makeTranslator } from 'sos-common/js/utils/translations';
import { setInnerHtml } from 'sos-common/js/utils/helpers';
import { RadioButtonGroup } from 'sos-common/js/components/FormControls/RadioButtonGroup';
import { RadioButton } from 'sos-common/js/components/FormControls/RadioButton';
import { TextInput, TextInputProps } from 'sos-common/js/components/FormControls/TextInput';
import { CheckBox, CheckBoxState, CheckBoxProps } from 'sos-common/js/components/FormControls/CheckBox';
import { SelectBox, SelectBoxProps } from 'sos-common/js/components/FormControls/SelectBox';
import {
  MultiSelectComboboxFormControl,
  IMultiSelectComboboxFormControlProps,
} from 'sos-common/js/components/FormControls/MultiSelectComboboxFormControl';
import {
  AnsokanFormStepOneModel,
  EducationLocation,
  FileUploadText,
  LegAnsokan,
  LegAnsokanPayload,
} from '../../models/ansokan.model';
import AttentionBox from 'sos-common/js/components/AttentionBox/Attentionbox';

import {
  LegAnsokanFormFieldName,
  ILegAnsokanFormProps,
  ILegAnsokanFormState,
  LegAnsokanField,
  Yrke,
} from './LegAnsokanForm.types';
import { saveAnsokan } from '../../services/ansokanform.save.service';
import { FormFieldFile } from 'sos-common/js/commonTypes/formField.types';
import LoadingSpinner from 'sos-common/js/components/LoadingSpinner/LoadingSpinner';
import { FieldMap } from './FieldMap';
import { FileExtendedDetails, FileState } from 'sos-common/js/commonTypes/fileupload.types';
import { doDelete, doPost } from 'sos-eservice-common/js/services/fetch.service';
import { ResponseError } from 'sos-common/js/utils/ResponseError';
import { DialogueError } from 'sos-common/js/components/DialogueError/DialogueError';
import { getDialogueByResponse } from '../../helpers/dialogue.helper';
import { MultiSelectItem } from 'sos-common/js/commonTypes/multiSelect.types';
import { findFileUploadTextByFieldName, getFileUploadTexts } from '../../helpers/fileUploadHelpers';

let ModalTranslate: (key: string, defaultValue?: string) => string;
let Translations: (key: string, defaultValue?: string) => string;
export class LegAnsokanForm extends React.Component<ILegAnsokanFormProps, ILegAnsokanFormState> {
  private _latestResponseError: ResponseError;
  private readonly API_ROUTE = '/_api/ansokan';
  constructor(props: ILegAnsokanFormProps) {
    super(props);

    ModalTranslate = makeTranslator(props.modalTranslations);
    Translations = makeTranslator(props.translations);
    const fieldMap = new FieldMap(
      props.model,
      props.ansokan,
      props.formTexts,
      props.educationLocation,
      Translations,
      this.addFile,
      this.removeFile,
      this.addMultiSelectItem,
    );
    fieldMap.addOnChangeEventHandler(this.inputChanged, this.onChangeTermsAndCondition);

    this.state = {
      fieldMap,
      payload: this.getDefaultPayload(props.ansokan),
      showSpinner: false,
      isLoading: false,
      isSaveErrorModalOpen: false,
      showAddressInfo: false,
      LegitimationOtherCountry: this.props.ansokan.Utbildning.legitimationFranAnnatLand ?? false,
      AssessmentAllowContact: this.props.ansokan.Utbildning.TillatelseKontaktaSkolaMyndighet,
    };
  }

  componentDidMount() {
    let mailfields = document.querySelectorAll('#Epost,#BekraftaEpost');

    //.foreach() does not work in IE
    for (let index = 0; index < mailfields.length; index++) {
      const element = mailfields[index];
      element.addEventListener('paste', (e: ClipboardEvent) => {
        e.preventDefault();
      });
    }

    // if (/MSIE|Trident/.test(navigator.userAgent)) {

    // }

    //console.log(new Date().getTime().toString())
  }

  addMultiSelectItem = (selectedItems: MultiSelectItem[]) => {
    const { fieldMap, payload } = this.state;
    payload[LegAnsokanFormFieldName.LegitimationAndraLanderId] = selectedItems.map((x) => x.key);
    const fieldState = fieldMap.get(LegAnsokanFormFieldName.LegitimationAndraLanderId);
    fieldState.props.value = selectedItems.map((x) => x.key);

    const isValid = fieldMap.validateFieldWithErrorMessage(fieldState);

    this.setState(
      {
        fieldMap: fieldMap.clone(),
        payload,
        showSpinner: true,
        isLoading: true,
      },
      () => {
        let partialState = {} as ILegAnsokanFormState;
        saveAnsokan(this.state.payload, this.API_ROUTE).then((response) => {
          if (response instanceof ResponseError) {
            this._latestResponseError = response;
            partialState.isSaveErrorModalOpen = true;
          } else {
            this.updateEnableStateForGranskaOchBetalaButton(fieldMap);
            partialState.isSaveErrorModalOpen = false;
          }

          this.setState({
            showSpinner: false,
            isLoading: false,
            ...partialState,
          });
        });
      },
    );
  };

  onChangeTermsAndCondition = (field: CheckBoxState) => {
    const fieldMap = this.state.fieldMap.clone();
    const fieldState = fieldMap.get(LegAnsokanFormFieldName.TermsAndConditions);
    fieldState.props.value = field.value;
    fieldMap.validateAllFieldsWithErrorMessages();
    this.setState({ fieldMap: fieldMap.clone() });
  };

  getDefaultPayload = (ansokan: LegAnsokan): LegAnsokanPayload => {
    return {
      AnsokanId: ansokan.Id,
      Epost: ansokan.Epost ?? null,
      Telefonnummer: ansokan.Telefonnummer ?? null,
      LarosateId: ansokan.Utbildning?.LarosateId ?? null,
      LarosateNamn: ansokan.Utbildning?.LarosateNamn ?? null,
      ExamensDatum: ansokan.Utbildning?.ExamensDatum ?? null,
      Examensar: ansokan.Utbildning?.Examensar ?? null,
      AccepteratVillkor: ansokan.AccepteratVillkor ?? null,
      CheckboxValue: ansokan.CheckboxValue,
      YrkeId: this.props.model.OccupationId,
      UtbildningslandId: ansokan.Utbildning?.UtbildningslandId ?? null,
      UtbildningslandNamn: ansokan.Utbildning?.UtbildningslandNamn ?? null,
      Utbildningstitel: ansokan.Utbildning?.Utbildningstitel ?? null,
      Utbildningslangd: ansokan.Utbildning?.Utbildningslangd ?? null,
      UtbildningPaborjad: ansokan.Utbildning?.UtbildningPaborjad ?? null,
      DatumForLegitimeradOmYrkesbehorighet: ansokan.Utbildning?.DatumForLegitimeradOmYrkesbehorighet ?? null,
      LegitimationAndraLander: ansokan.Utbildning?.LegitimationAndraLander ?? null,
      LegitimationFranAnnatLand: ansokan.Utbildning?.legitimationFranAnnatLand ?? null,
      DiarienummerTidigareAnsokan: ansokan.Utbildning?.DiarienummerTidigareAnsokan ?? null,
      EftergymnasialUtbildning: ansokan.Utbildning?.EftergymnasialUtbildning ?? null,
      ArbetatEfterExamen: ansokan.Utbildning?.ArbetatEfterExamen ?? null,
      TillatelseKontaktaSkolaMyndighet: ansokan.Utbildning?.TillatelseKontaktaSkolaMyndighet ?? null,
      MotiveringEjKontaktaSkolaMyndighet: ansokan.Utbildning?.MotiveringEjKontaktaSkolaMyndighet ?? null,
      BetaltVidGranskning: ansokan.Utbildning?.BetaltVidGranskning ?? null,
      DatumForTidigareBetalning: ansokan.Utbildning?.DatumForTidigareBetalning ?? null,
      GjortKompletterandeUtbildning: ansokan.Utbildning?.GjortKompletterandeUtbildning ?? null,
    };
  };

  //we _probably_ don't need to trigger an extra update call here
  onGranskaOchBetalaClick = () => {
    const ansokanId = this.props.ansokan.Id;
    window.location.href = `/${this.props.stepTwoPageLink}/?ansokanId=${ansokanId}`;
  };

  _removeNonExistingFileFromList = () => {
    const fieldMap = this.state.fieldMap.clone();
    fieldMap.removeAllNonExistingFields();
    this.setState({ fieldMap });
  };

  _setPreFileSaveStateInGui = (fieldMap: FieldMap, file: FileExtendedDetails, field: FormFieldFile) => {
    file.FileId = null; //trigger the loading file spinner.
    file.status = FileState.UPLOADING;

    this.updateFileState(fieldMap, field);
    fieldMap.setFileErrorMessage(null, field.fieldName);
  };

  updateFileState = (fieldMap: FieldMap, field: FormFieldFile) => {
    fieldMap.setFileValueByFieldName(field);
    const fieldState = fieldMap.get(field.fieldName);
    fieldMap.validateFieldWithErrorMessage(fieldState);
  };

  updateEnableStateForGranskaOchBetalaButton = (fieldMap: FieldMap) => {
    //NOTE: although the  fieldMap.validateAllFields could be called directly, it is better to have this intermediate method in order to explain the purpose in the GUI of calling it.
    fieldMap.validateAllFields();
  };

  inputChanged = (field: LegAnsokanField) => {
    const { fieldMap, payload } = this.state;

    let legOtherCountry = null;
    let assessmentAllowContact = null;
    let fieldName = '';

    //TODO: Why does field.fieldName for radioButtonGroup come as object? Fix the root cause and remove this ugly check :)
    if (typeof field.fieldName === 'object') {
      let fieldData = field as any;
      fieldName = fieldData.fieldName.fieldName;
    } else {
      fieldName = field.fieldName;
    }
    //ENDTODO

    if (fieldName === LegAnsokanFormFieldName.LegitimationOtherCountry) {
      let otherLegCountry = fieldMap.get(LegAnsokanFormFieldName.LegitimationAndraLanderId);

      if (field.value === true) {
        otherLegCountry.props.isRequired = true;
      } else if (field.value === false) {
        otherLegCountry.props.isRequired = false;
        (otherLegCountry.props as any).items = (otherLegCountry.props as any).items.map((x) => ({
          ...x,
          isSelectedByDefault: false,
        }));
        payload[LegAnsokanFormFieldName.LegitimationAndraLanderId] = null;
      }
      legOtherCountry = field.value;
    }

    if (fieldName === LegAnsokanFormFieldName.AssessmentAllowContact) {
      let denyReason = fieldMap.get(LegAnsokanFormFieldName.AssessmentDenyReason);

      if (field.value === false) {
        denyReason.props.isRequired = true;
      } else if (field.value === true) {
        denyReason.props.isRequired = false;
        denyReason.props.value = null;
        payload[LegAnsokanFormFieldName.AssessmentDenyReason] = null;
      }
      assessmentAllowContact = field.value;
    }

    if (fieldName === LegAnsokanFormFieldName.PaidAssessmentFeeEarlier) {
      let paymentDateField = fieldMap.get(LegAnsokanFormFieldName.PaymentDate);
      if (field.value === true) {
        paymentDateField.ShowField = true;
        payload[LegAnsokanFormFieldName.PaymentDate] = paymentDateField.props.value;
      } else {
        paymentDateField.ShowField = false;
        payload[LegAnsokanFormFieldName.PaymentDate] = undefined;
      }
    }

    let fieldState = fieldMap.get(fieldName);
    fieldState.props.value = field.value;
    fieldMap.validateFieldWithErrorMessage(fieldState);
    this.updateEnableStateForGranskaOchBetalaButton(fieldMap);

    if (this.props.model.OccupationId === Yrke.Fysioterapeut) {
      if (fieldName == LegAnsokanFormFieldName.CheckboxValue) {
        // payload[LegAnsokanFormFieldName.CheckboxValue] = field.value;
        fieldMap.setGotSjukgymnastExamination();
        if (field.value) {
          fieldMap.removeFilesByTag(LegAnsokanFormFieldName.PrimaryFiles);
        }
      }
    }

    const isValid = fieldMap.validateFieldWithErrorMessage(fieldState);
    if (field.fieldName === LegAnsokanFormFieldName.ExaminationDate) {
      if (!isValid) {
        this.setState({ fieldMap: fieldMap.clone() });
        return;
      }
    }
    if (fieldName === LegAnsokanFormFieldName.DateOfLegitimationCertificate) {
      if (!isValid) {
        this.setState({ fieldMap: fieldMap.clone() });
        return;
      }
    }

    if (fieldName === LegAnsokanFormFieldName.ExaminationYear) {
      if (!isValid) {
        this.setState({ fieldMap: fieldMap.clone() });
        return;
      }
    }

    if (
      fieldName === LegAnsokanFormFieldName.Telefonnummer ||
      fieldName === LegAnsokanFormFieldName.Diarienummer ||
      fieldName === LegAnsokanFormFieldName.AssessmentEducationCountry ||
      fieldName === LegAnsokanFormFieldName.AssessmentVocationalYears ||
      fieldName === LegAnsokanFormFieldName.AssessmentStartYear ||
      fieldName === LegAnsokanFormFieldName.AssessmentGraduationYear ||
      fieldName === LegAnsokanFormFieldName.AssessmentDenyReason
    ) {
      if (!isValid) {
        this.setState({ fieldMap: fieldMap.clone() });
        return;
      }
    }

    if (fieldName === LegAnsokanFormFieldName.ConfirmEmail) {
      this.setState({ fieldMap: fieldMap.clone() });
      return; //We don't save if the confirmation email.
    }
    payload[fieldName] = field.value;

    this.setState(
      {
        fieldMap: fieldMap.clone(),
        payload,
        showSpinner: true,
        isLoading: true,
        LegitimationOtherCountry: legOtherCountry ?? this.state.LegitimationOtherCountry,
        AssessmentAllowContact: assessmentAllowContact ?? this.state.AssessmentAllowContact,
      },
      () => {
        let partialState = {} as ILegAnsokanFormState;
        saveAnsokan(this.state.payload, this.API_ROUTE).then((response) => {
          if (response instanceof ResponseError) {
            this._latestResponseError = response;
            if (fieldName === LegAnsokanFormFieldName.Email) {
              fieldMap.setErrorMessage(response.body.errorMessage, fieldName);
            } else {
              partialState.isSaveErrorModalOpen = true;
            }
          } else {
            this.updateEnableStateForGranskaOchBetalaButton(fieldMap);
            partialState.isSaveErrorModalOpen = false;
          }

          this.setState({
            showSpinner: false,
            isLoading: false,
            ...partialState,
          });
        });
      },
    );
  };

  renderEducatedInSwedenFields = () => {
    const { fieldMap } = this.state;
    const { model } = this.props;

    const primaryFilesFieldState = fieldMap.get(LegAnsokanFormFieldName.PrimaryFiles);
    const secondaryFilesFieldState = fieldMap.get(LegAnsokanFormFieldName.SecondaryFiles);
    return (
      <>
        <section aria-label={Translations('educationSectionHeaderInSweden')}>
          <h2>{Translations('yourDegree')}</h2>
          <div className="row">
            <div className="col-sm-6">
              <SelectBox {...(fieldMap.get(LegAnsokanFormFieldName.SchoolSelect).props as SelectBoxProps)} />
            </div>
          </div>
          <label htmlFor={LegAnsokanFormFieldName.ExaminationDate}>
            {Translations('datumExamenUtfardat')} {Translations('mandatory')}
          </label>
          <div className="row">
            <div className="col-sm-6">
              <TextInput {...(fieldMap.get(LegAnsokanFormFieldName.ExaminationDate).props as TextInputProps)} />
            </div>
          </div>

          {model.OccupationId === Yrke.Fysioterapeut && (
            <>
              <hr />
              <CheckBox
                label={Translations('redanLegitimationSom')}
                {...(fieldMap.get(LegAnsokanFormFieldName.CheckboxValue).props as CheckBoxProps)}
              />
            </>
          )}
        </section>
        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(LegAnsokanFormFieldName.PrimaryFiles) && (
            <>
              <hr />
              {model.PrimaryFileUploadText && (
                <div dangerouslySetInnerHTML={setInnerHtml(model.PrimaryFileUploadText.IntroText)} />
              )}
              <Fileupload {...(primaryFilesFieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>

        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(LegAnsokanFormFieldName.SecondaryFiles) && model.SecondaryFileUploadText && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.SecondaryFileUploadText.IntroText)} />
              <Fileupload {...(secondaryFilesFieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>
      </>
    );
  };

  renderFileUploads = () => {
    const { fieldMap } = this.state;
    const { model, formTexts } = this.props;
    const fileupload1FieldState = fieldMap.get(LegAnsokanFormFieldName.FileUpload1);
    const fileupload2FieldState = fieldMap.get(LegAnsokanFormFieldName.FileUpload2);
    const fileupload3FieldState = fieldMap.get(LegAnsokanFormFieldName.FileUpload3);
    const fileupload4FieldState = fieldMap.get(LegAnsokanFormFieldName.FileUpload4);
    const fileupload5FieldState = fieldMap.get(LegAnsokanFormFieldName.FileUpload5);
    const fileupload6FieldState = fieldMap.get(LegAnsokanFormFieldName.FileUpload6);
    const fileupload7FieldState = fieldMap.get(LegAnsokanFormFieldName.FileUpload7);
    return (
      <>
        {fieldMap.showFieldFor(LegAnsokanFormFieldName.FileUpload1) &&
          model.FileUploadText1 &&
          this.props.educationLocation !== EducationLocation.EducatedInSweden && (
            <>
              <hr />{' '}
              {formTexts.DocumentInfo && (
                <AttentionBox
                  cssClass="attentionbox--brown m-b-2 m-t-2"
                  icon="Infocirkel_normal20px20px"
                  bodytext={formTexts.DocumentInfo}
                />
              )}
              {model.FileUploadText1 && <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText1.IntroText)} />}
              <Fileupload {...(fileupload1FieldState.props as IFileUploadProps)} />
            </>
          )}

        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(LegAnsokanFormFieldName.FileUpload2) && model.FileUploadText2 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText2.IntroText)} />
              <Fileupload {...(fileupload2FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>

        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(LegAnsokanFormFieldName.FileUpload3) &&
            model.FileUploadText3 &&
            this.props.educationLocation !== EducationLocation.EducatedInSweden && (
              <>
                <hr />
                <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText3.IntroText)} />
                <Fileupload {...(fileupload3FieldState.props as IFileUploadProps)} />
              </>
            )}
        </div>

        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(LegAnsokanFormFieldName.FileUpload4) &&
            model.FileUploadText4 &&
            this.props.educationLocation !== EducationLocation.EducatedInSweden && (
              <>
                <hr />
                <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText4.IntroText)} />
                <Fileupload {...(fileupload4FieldState.props as IFileUploadProps)} />
              </>
            )}
        </div>
        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(LegAnsokanFormFieldName.FileUpload5) &&
            model.FileUploadText5 &&
            this.props.educationLocation !== EducationLocation.EducatedInSweden && (
              <>
                <hr />
                <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText5.IntroText)} />
                <Fileupload {...(fileupload5FieldState.props as IFileUploadProps)} />
              </>
            )}
        </div>
        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(LegAnsokanFormFieldName.FileUpload6) &&
            model.FileUploadText6 &&
            this.props.educationLocation !== EducationLocation.EducatedInSweden && (
              <>
                <hr />
                <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText6.IntroText)} />
                <Fileupload {...(fileupload6FieldState.props as IFileUploadProps)} />
              </>
            )}
        </div>
        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(LegAnsokanFormFieldName.FileUpload7) && model.FileUploadText7 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText7.IntroText)} />
              <Fileupload {...(fileupload7FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>
      </>
    );
  };

  renderEducatedOutsideSweden = () => {
    return (
      <>
        {this.props.educationLocation === EducationLocation.EducatedOutsideEuEes && (
          <>
            <div className="row m-b-2">
              <div className="col-sm-6">
                <TextInput
                  {...(this.state.fieldMap.get(LegAnsokanFormFieldName.Diarienummer).props as TextInputProps)}
                />
              </div>
            </div>
            <hr />
          </>
        )}

        <section aria-label={Translations('educationSectionHeader')}>
          <h2>{Translations('educationSectionHeader')}</h2>
          {this.props.educationLocation === EducationLocation.EducatedOutsideEuEes ? (
            <>
              <div className="row m-b-2">
                <div className="col-sm-6">
                  <TextInput
                    {...(this.state.fieldMap.get(LegAnsokanFormFieldName.ExaminationYear).props as TextInputProps)}
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              {this.props.educationLocation === EducationLocation.EducatedInEuEes && (
                <div className="row m-b-2">
                  <div className="col-sm-6">
                    <SelectBox
                      {...(this.state.fieldMap.get(LegAnsokanFormFieldName.UtbildningsLand).props as SelectBoxProps)}
                    />
                  </div>
                </div>
              )}
              <div className="row m-b-2">
                <div className="col-sm-6">
                  <TextInput
                    {...(this.state.fieldMap.get(LegAnsokanFormFieldName.EducationTitle).props as TextInputProps)}
                  />
                </div>
                <div className="col-sm-6">
                  <TextInput
                    {...(this.state.fieldMap.get(LegAnsokanFormFieldName.EducationLength).props as TextInputProps)}
                  />
                </div>
              </div>
              <div className="row m-b-2">
                <div className="col-sm-6">
                  <TextInput
                    {...(this.state.fieldMap.get(LegAnsokanFormFieldName.ExaminationYear).props as TextInputProps)}
                  />
                </div>
                <div className="col-sm-6">
                  <TextInput
                    {...(this.state.fieldMap.get(LegAnsokanFormFieldName.DateOfLegitimationCertificate)
                      .props as TextInputProps)}
                  />
                </div>
              </div>
              <RadioButtonGroup {...this.state.fieldMap.get(LegAnsokanFormFieldName.LegitimationOtherCountry).props}>
                <RadioButton value={true} label={Translations('yesChoice')} />
                <RadioButton value={false} label={Translations('noChoice')} />
              </RadioButtonGroup>
              {this.state.LegitimationOtherCountry && (
                <div className="row m-b-2">
                  <div className="col-sm-6">
                    <MultiSelectComboboxFormControl
                      {...(this.state.fieldMap.get(LegAnsokanFormFieldName.LegitimationAndraLanderId)
                        .props as IMultiSelectComboboxFormControlProps)}
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </section>
        {this.renderFileUploads()}

        <section aria-labelledby="fee-heading">
          {this.props.educationLocation === EducationLocation.EducatedOutsideEuEes && (
            <>
              <hr role="presentation" />
              <h3 id="fee-heading">{Translations('eServiceForm/assessmentFeeHeader')}</h3>
              <RadioButtonGroup {...this.state.fieldMap.get(LegAnsokanFormFieldName.PaidAssessmentFeeEarlier).props}>
                <RadioButton value={true} label={Translations('yesChoice')} />
                <RadioButton value={false} label={Translations('noChoice')} />
              </RadioButtonGroup>
              {this.state.fieldMap.get(LegAnsokanFormFieldName.PaymentDate).ShowField && (
                <div className="m-b-2">
                  <TextInput
                    {...(this.state.fieldMap.get(LegAnsokanFormFieldName.PaymentDate).props as TextInputProps)}
                  />
                </div>
              )}
              {this.props.model.OccupationId === Yrke.Lakare &&
                this.state.fieldMap.get(LegAnsokanFormFieldName.CompletedSupplementaryEducation)?.props && (
                  <div className="m-b-2">
                    <RadioButtonGroup
                      {...this.state.fieldMap.get(LegAnsokanFormFieldName.CompletedSupplementaryEducation).props}>
                      <RadioButton value={true} label={Translations('yesChoice')} />
                      <RadioButton value={false} label={Translations('noChoice')} />
                    </RadioButtonGroup>
                  </div>
                )}
            </>
          )}
        </section>
      </>
    );
  };

  renderAssessmentFields = () => {
    const { fieldMap, AssessmentAllowContact } = this.state;
    return (
      <>
        <div className="row m-b-2">
          <div className="col-sm-6">
            <TextInput {...(fieldMap.get(LegAnsokanFormFieldName.Diarienummer).props as TextInputProps)} />
          </div>
        </div>
        <hr />
        <section aria-label={Translations('granskning/sectionHeader')}>
          <h2>{Translations('granskning/sectionHeader')}</h2>
          <RadioButtonGroup
            {...this.state.fieldMap.get(LegAnsokanFormFieldName.AssessmentEducationAfterHighSchool).props}>
            <RadioButton value={true} label={Translations('yesChoice')} />
            <RadioButton value={false} label={Translations('noChoice')} />
          </RadioButtonGroup>
          <div className="row m-b-2">
            <div className="col-sm-6">
              <TextInput {...(fieldMap.get(LegAnsokanFormFieldName.AssessmentDegree).props as TextInputProps)} />
            </div>
            <div className="col-sm-6">
              <TextInput
                {...(fieldMap.get(LegAnsokanFormFieldName.AssessmentEducationPlace).props as TextInputProps)}
              />
            </div>
          </div>
          <div className="row m-b-2">
            <div className="col-sm-6">
              <TextInput
                {...(fieldMap.get(LegAnsokanFormFieldName.AssessmentVocationalYears).props as TextInputProps)}
              />
            </div>
            <div className="col-sm-6">
              <TextInput
                {...(fieldMap.get(LegAnsokanFormFieldName.AssessmentEducationCountry).props as TextInputProps)}
              />
            </div>
          </div>
          <div className="row m-b-2">
            <div className="col-sm-6">
              <TextInput {...(fieldMap.get(LegAnsokanFormFieldName.AssessmentStartYear).props as TextInputProps)} />
            </div>
            <div className="col-sm-6">
              <TextInput
                {...(fieldMap.get(LegAnsokanFormFieldName.AssessmentGraduationYear).props as TextInputProps)}
              />
            </div>
          </div>
          <RadioButtonGroup {...this.state.fieldMap.get(LegAnsokanFormFieldName.AssessmentWorkedAfterGraduation).props}>
            <RadioButton value={true} label={Translations('yesChoice')} />
            <RadioButton value={false} label={Translations('noChoice')} />
          </RadioButtonGroup>
          <RadioButtonGroup {...this.state.fieldMap.get(LegAnsokanFormFieldName.AssessmentAllowContact).props}>
            <RadioButton value={true} label={Translations('yesChoice')} />
            <RadioButton value={false} label={Translations('noChoice')} />
          </RadioButtonGroup>
          <div role="log" aria-live="polite">
            {AssessmentAllowContact === false && (
              <div className="row m-b-2">
                <div className="col-sm-12">
                  <TextInput
                    wrapperClassName="d-flex flex-column"
                    {...(fieldMap.get(LegAnsokanFormFieldName.AssessmentDenyReason).props as TextInputProps)}
                  />
                </div>
              </div>
            )}
          </div>
        </section>
        {this.renderFileUploads()}
      </>
    );
  };

  addFile = (field: FormFieldFile) => {
    const { model } = this.props;
    const fieldMap = this.state.fieldMap.clone();
    const file = field.value.filter((f) => !f.FileId)[0];

    this._setPreFileSaveStateInGui(fieldMap, file, field);
    this.setState({ fieldMap, isLoading: true });

    const form = new FormData();
    form.append(file.OriginalFilename, file.file);
    const fileUploadTexts = getFileUploadTexts(model) as FileUploadText;
    const fileUploadText = findFileUploadTextByFieldName(field.fieldName, fileUploadTexts);
    let dhsCategory = fileUploadText?.DHSCategory?.Category;

    if (field.fieldName == LegAnsokanFormFieldName.PrimaryFiles) {
      dhsCategory = model.PrimaryFileUploadText?.DHSCategory?.Category;
    }
    if (field.fieldName == LegAnsokanFormFieldName.SecondaryFiles) {
      dhsCategory = model.SecondaryFileUploadText?.DHSCategory?.Category;
    }

    const fileTag = field.fieldName;
    const apiPathExtension = `ansokan/attachbilaga/${this.props.ansokan.Id.toString()}/${fileTag}/${
      dhsCategory ? dhsCategory : ''
    }`;
    const path = `/_api/${apiPathExtension}`;
    return doPost<FileExtendedDetails>(path, form)
      .then((response) => {
        const fieldMap = this.state.fieldMap.clone();
        let partialState = {} as ILegAnsokanFormState;
        if (response instanceof ResponseError) {
          this._latestResponseError = response;
          if (response.body.detailCode) {
            partialState.isSaveErrorModalOpen = true;
          } else {
            //only show file error if there is no timeout
            fieldMap.setFileErrorMessage(response.body.errorMessage, field.fieldName);
            this._removeNonExistingFileFromList();
            partialState.isSaveErrorModalOpen = false;
          }
        } else {
          const fileResponse = response as any;
          file.FileId = fileResponse.Id.toString();
          file.status = FileState.SETTLED;
          this.updateFileState(fieldMap, field);
          partialState.isSaveErrorModalOpen = false;
        }
        this.updateEnableStateForGranskaOchBetalaButton(fieldMap);
        this.setState({ fieldMap, isLoading: false, ...partialState });
      })
      .catch((err: ResponseError) => {
        fieldMap.setFileErrorMessage(err.body.errorMessage, field.fieldName); //TODO: Make sure server returns a proper error message to the end user.
        this._removeNonExistingFileFromList();
      });
  };

  removeFile = (file: FileExtendedDetails, fieldName: string, field: FormFieldFile) => {
    const fileId = file.FileId;
    const ansokanId = this.props.ansokan.Id;

    const fieldMap = this.state.fieldMap.clone();
    this._setPreFileSaveStateInGui(fieldMap, file, field);
    this.setState({ fieldMap });

    const path = `/_api/ansokan/deletefile/${fileId}/${ansokanId}`;

    return doDelete<FileExtendedDetails>(path)
      .then((response) => {
        const fieldMap = this.state.fieldMap.clone();
        let partialState = {} as ILegAnsokanFormState;
        if (response instanceof ResponseError) {
          this._latestResponseError = response;
          if (response.body.detailCode) {
            partialState.isSaveErrorModalOpen = true;
          } else {
            fieldMap.setFileErrorMessage(response.body.errorMessage, field.fieldName);
            file.FileId = fileId;
            file.status = FileState.SETTLED;
            this.updateFileState(fieldMap, field);
            partialState.isSaveErrorModalOpen = false;
          }
        } else {
          const fileResponse = response as any;
          const deletedId = fileResponse.id;
          this._removeNonExistingFileFromList();
          const fieldState = fieldMap.get(field.fieldName);
          fieldMap.validateFieldWithErrorMessage(fieldState);
          partialState.isSaveErrorModalOpen = false;
        }
        this.updateEnableStateForGranskaOchBetalaButton(fieldMap);
        this.setState({ fieldMap, isLoading: false, ...partialState });
        return response;
      })
      .catch((err: ResponseError) => {
        //TODO: Do we need this? I guess it only occurs in case of time out providing that Error handling is done on the server.
        //TODO: Tobias?: Is there a timeout? How is this set in the fetch function?
        fieldMap.setFileErrorMessage(err.body.errorMessage, field.fieldName);
        file.FileId = fileId;
        file.status = FileState.SETTLED;
        this.updateFileState(fieldMap, field);
      });
  };

  onModalClose = () => {
    this.setState({
      isSaveErrorModalOpen: false,
    });
  };

  getEducationLocationPreamleText = (educationLoc): string => {
    switch (educationLoc) {
      case EducationLocation.EducatedOutsideEuEes3year:
        return Translations('legitimationsAnsokan/educatedOutsideEuEesPreambleText');
      case EducationLocation.EducatedInEuEes:
        return Translations('legitimationsAnsokan/educatedInEuEesPreambleText');
      case EducationLocation.EducatedOutsideEuEes:
        return Translations('legitimationsAnsokan/educatedOutsideEuEesLess3YearsPreambleText');
      case EducationLocation.EducatedOutsideEuEesAssessment:
        return Translations('granskning/educatedOutsideEuEesAssessmentPreambleText');
      default:
        return Translations('legitimationsAnsokan/educatedInSwedenText');
    }
  };

  getAddressInfo = (): JSX.Element => {
    const { formTexts, folkbokforing } = this.props;

    if (folkbokforing) {
      //NOTE: If any error occurs with extracting this info on the server, this object is always null, never otherwise. The server side code takes care of logging the error with information about it.
      return (
        <div className="importantinfo importantinfo--futura m-b-4" aria-label="Dina folkbokföringsuppgifter">
          <div>{folkbokforing.Namn}</div>
          <div>{folkbokforing.PersonNummer}</div>
          {folkbokforing.CareOf && <div>{`c/o ${folkbokforing.CareOf}`}</div>}
          {folkbokforing.Utdelningsadress1 && <div>{folkbokforing.Utdelningsadress1}</div>}
          {folkbokforing.Utdelningsadress2 && <div>{folkbokforing.Utdelningsadress2}</div>}

          <div>
            {folkbokforing.PostNr && <span>{folkbokforing.PostNr}</span>}{' '}
            {folkbokforing.Postort && <span>{folkbokforing.Postort}</span>}
          </div>
        </div>
      );
    }

    return (
      <div className="m-b-4">
        <AttentionBox
          heading={formTexts.PersonuppgifterCouldNotBeLoadedHeading}
          bodytext={formTexts.PersonuppgifterCouldNotBeLoadedBody}
          icon="Info"
          cssClass="attentionbox--red"
        />
      </div>
    );
  };

  onShowAddressClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    this.setState((prevState) => {
      return { showAddressInfo: !prevState.showAddressInfo };
    });
  };

  public render() {
    const { model, formTexts, deleteLink, myPage, educationLocation } = this.props;
    const { fieldMap, showSpinner, isLoading, isSaveErrorModalOpen, showAddressInfo } = this.state;

    return (
      <>
        {isSaveErrorModalOpen && (
          <DialogueError
            dialogueErrorBody={getDialogueByResponse(this._latestResponseError, myPage, null, Translations)}
            isModalOpen={isSaveErrorModalOpen}
            onModalClose={this.onModalClose}
            enableCloseIcon={false}
            shouldCloseOnOverlayClick={false}
          />
        )}
        <p className="preamble">
          {educationLocation === EducationLocation.EducatedOutsideEuEesAssessment ? (
            <>
              {this.getEducationLocationPreamleText(educationLocation)} <strong>{model.YrkesNamn.toLowerCase()}</strong>
            </>
          ) : (
            <>
              {Translations('legitimationsAnsokan/preamble')}
              <strong>{model.YrkesNamn.toLowerCase()}</strong> {this.getEducationLocationPreamleText(educationLocation)}
            </>
          )}
        </p>
        {model.ImportantInformation && (
          <div
            className="importantinfo importantinfo--lightgray importantinfo--sharp"
            dangerouslySetInnerHTML={setInnerHtml(model.ImportantInformation)}
          />
        )}
        <hr />
        {formTexts.PersonuppgifterHeading && <h2>{formTexts.PersonuppgifterHeading}</h2>}
        {formTexts.PersonuppgifterBody && <div dangerouslySetInnerHTML={setInnerHtml(formTexts.PersonuppgifterBody)} />}
        <button className="button button--border m-b-2" onClick={this.onShowAddressClick}>
          {!showAddressInfo ? Translations('showButton') : Translations('hideButton')}{' '}
          {Translations('folkbokforingsadress')}
        </button>
        <div role="log" aria-live="polite">
          {showAddressInfo && this.getAddressInfo()}
        </div>
        <div className="row">
          <div className="col-sm-6">
            <TextInput {...(fieldMap.get(LegAnsokanFormFieldName.Email).props as TextInputProps)} />
          </div>
          <div className="col-sm-6">
            <TextInput {...(fieldMap.get(LegAnsokanFormFieldName.ConfirmEmail).props as TextInputProps)} />
          </div>
        </div>
        <hr />
        {educationLocation === EducationLocation.EducatedInSweden
          ? this.renderEducatedInSwedenFields()
          : educationLocation === EducationLocation.EducatedOutsideEuEesAssessment
          ? this.renderAssessmentFields()
          : this.renderEducatedOutsideSweden()}
        {model.ExtraInformation && (
          <>
            <hr />
            <div dangerouslySetInnerHTML={setInnerHtml(model.ExtraInformation)} />
          </>
        )}

        <hr />
        <CheckBox {...(fieldMap.get(LegAnsokanFormFieldName.TermsAndConditions).props as CheckBoxProps)} />
        {formTexts.SamtyckeExplanation && <div dangerouslySetInnerHTML={setInnerHtml(formTexts.SamtyckeExplanation)} />}
        <div className="form-submit">
          <button
            className="button relative"
            onClick={this.onGranskaOchBetalaClick}
            disabled={isLoading || !fieldMap.allFieldsAreValid || showSpinner}>
            {Translations('reviewAndPayButton')}
            {showSpinner && <LoadingSpinner cssClasses="button-spinner" />}
          </button>
        </div>
        <hr />
        <div className="delete-order">
          <DeleteButton
            postLink={deleteLink}
            disabled={false}
            actionText={ModalTranslate('delete')}
            cancelText={ModalTranslate('cancel')}
            modalHeading={ModalTranslate('heading')}
            modalBody={ModalTranslate('text')}
          />
        </div>
      </>
    );
  }
}
